import _ from 'lodash'
import SqlConsoleModel from 'scoreboard/components/sql-console/sql-console-model'
import NewSqlConsoleView from './new-sql-console'

var SqlConsolePath = {
	steps: [{
		titleCode: 'report.sqlConsole.title',
		view: NewSqlConsoleView,
		validate: function (attrs, opts) {
			var query = attrs.query || ''
			return _.trim(query).length == 0
		}
	}],
	model: SqlConsoleModel
}

export default SqlConsolePath

SqlConsolePath.__filename__ = 'reports/wizard/sql-console/sql-console-path.js'
